<template>
  <footer>
    <div class="container">

      <p> Healing Path</p>
      <ul>
        <li><a href="/privacy">Privacy Policy</a></li>
        <!-- <li><a href="/terms-of-service">Terms of Service</a></li> -->
        <li><a href="/contact">Kontakt oss</a></li>
      </ul>
    </div>

    <div class="social-media">
      <a href="https://www.facebook.com/groups/619230747104448" target="_blank" rel="noopener noreferrer">Facebook</a>
      <!-- <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a> -->
      <!-- <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a> -->
      <!-- <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a> -->
      <!-- <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">YouTube</a> -->
    </div>
    
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      // You can add any data properties if needed
    };
  },
  methods: {
    // You can add methods if needed
  }
}
</script>

<style lang="scss">
footer {
  background-color: $green;
  color: #fff;
  padding: 20px 0;
  text-align: center;
  height: 200px;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;

    p {
      margin: 0;
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;

      li {
        display: inline;
        margin-right: 15px;

        a {
          color: #fff;
          text-decoration: none;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  .social-media {
    margin-top: 10px;

    a {
      color: #fff;
      margin-right: 15px;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

</style>